/* eslint-disable prettier/prettier */
/* eslint-disable react/no-danger */
import React from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v1';
import {
  Alert,
  Box,
  IconButton,
  Modal,
  Paper,
  Stack,
  styled,
  Switch,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Typography
} from '@mui/material';
import { isEmpty } from 'lodash';
import CloseIcon from '@mui/icons-material/Close';
import HtmlIcon from '@mui/icons-material/Html';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import turf from '@turf/turf';


import { isAnnotationsLayer, isAnnotationsRealTime } from '../../../api/Layers/layer-operations';
import loadTableLayer from '../../../modules/load-table-layer';
import useTimeStore from '../ZustandProvider';

export const getPopupAnnotations = (properties, maxWidth) => {
  let popup = `<p style="word-wrap: break-word; margin: 0;width: ${maxWidth};"></p>`;
  properties.map(item => {
    if (item.elementType === 'icon') {
      if (!isEmpty(item.caption)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
          </div>
        </div>
      `;
      } else {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'iframe') {
      popup += `
                <div class="line-container">
                  <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                    <iframe src=${item.value} height="400" width="800" name="demo"></iframe>
                  </div>
                </div>
              `;
    } else if (item.elementType === 'image') {
      if (!isEmpty(item.value)) {
        if (!isEmpty(item.caption)) {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
              </div>
            </div>
          `;
        } else {
          popup += `
            <div class="line-container">
              <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
                <img src=${item.value} alt="Descripción de la imagen" style="max-width: ${maxWidth}; height: auto">
              </div>
            </div>
          `;
        }
      }
    } else if (
      item.elementType === 'textarea' ||
      (item.elementType === 'input' && item.dataType === 'text')
    ) {
      if (!isEmpty(item.value)) {
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="max-width: ${maxWidth}; word-wrap: break-word;"><h6><b>${item.value}</b></h6></p><hr>
          </div>
        </div>
      `;
      }
    } else if (item.elementType === 'video') {
      const obtenerVideoIdDesdeUrl = url => {
        const match = url.match(
          // eslint-disable-next-line no-useless-escape
          /(?:\?v=|&v=|youtu\.be\/|\/embed\/|\/v\/|\/e\/|youtu\.be\/|\/c\/|\/u\/|\/user\/\w+\/|embed\/|user\/\w+\/videos\/|\/v\/|\/R\/|\/C\/|\/E\/|\/G\/|\/H\/|\/J\/|\/K\/|\/L\/|\/N\/|\/P\/|\/Q\/|\/S\/|\/U\/|\/V\/|\/W\/|\/Y\/|\/hq\/|\/hqdefault\/|\/maxresdefault\/|\/thumbnail\/|\/1.jpg)([^#\&\?]*).*/
        );
        return match && match[1].length === 11 ? match[1] : null;
      };

      const obtenerSitioDesdeUrl = url => {
        const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([a-z0-9-]+)\./i);
        return match ? match[1].toLowerCase() : null;
      };

      const agregarEmbed = url => {
        if (url.includes('/embed/')) {
          return url;
        }
        const sitio = obtenerSitioDesdeUrl(url);

        if (sitio === 'youtube' || sitio === 'youtu') {
          const videoId = obtenerVideoIdDesdeUrl(url);
          if (videoId) {
            return `https://www.youtube.com/embed/${videoId}`;
          }
        }
        return url;
      };

      if (!isEmpty(item.caption) && !isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <p style="word-wrap: break-word; margin: 0;min-width: 10vw;"><h6><b>${item.caption}</b></h6></p>
            <iframe width="100%" height="auto" src=${videoURL} frameborder="0" style="max-width: ${maxWidth}"></iframe>
          </div>
        </div>
      `;
      } else if (!isEmpty(item.value)) {
        const videoURL = agregarEmbed(item.value);
        popup += `
        <div class="line-container">
          <div class="single-line" style="max-width: ${maxWidth}; word-wrap: break-word; margin-bottom: 0.5vh;">
            <iframe width="100%" height="auto" src=${videoURL} frameborder="0" style="max-width: ${maxWidth}"></iframe>
          </div>
        </div>
      `;
      }
    }
    return popup;
  });

  return popup;
};
let isAnnotationState = false;

const TableComponent = props => {
  const { isMapProp, layer, rowsInitial, ViewHtml } = props;
  const setGoToCoordinates = useTimeStore(state => state.setGoToCoordinates);

  const [contentTable, setContentTable] = React.useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [contentHeader, setContentHeader] = React.useState([]);

  const [page, setPage] = React.useState(1);
  const [rowsPerPage, setRowsPerPage] = React.useState(rowsInitial);
  const rowsPerPageOptions = [1, 2, 3, 5, 10, 15, 20, { label: 'All', value: -1 }];
  const [valueToShow, setValueToShow] = React.useState({});
  const [verHtml, setVerHtml] = React.useState(ViewHtml);

  const MaterialUISwitch = styled(Switch)(() => ({
    width: 44,
    height: 22,
    padding: 0,
    margin: 9,
    display: 'flex',
    transition: 'all .2s',
    borderRadius: 22 / 2,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      opacity: 1,
      backgroundColor: 'white',
      boxSizing: 'border-box',
      border: '1px solid white'
    },
    '& .MuiSwitch-thumb': {
      boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
      width: 17,
      height: 17,
      borderRadius: 17,
      backgroundColor: '#2A3F90'
    },
    '& .Mui-disabled + span': {
      backgroundColor: '#9f9f9f',
      border: '1px solid white'
    },
    '& .MuiSwitch-switchBase': {
      padding: 2.5,
      '&.Mui-focusVisible': {
        backgroundColor: 'rgba(198, 203, 212, 0.3)',
        '& .MuiSwitch-thumb': {
          backgroundColor: '#777E8C'
        }
      },
      '&.Mui-checked': {
        transform: 'translateX(22px)',
        '& + .MuiSwitch-track': {
          opacity: 1,
          backgroundColor: 'white',
          boxSizing: 'border-box',
          border: '1px solid white'
        },
        '& .MuiSwitch-thumb': {
          opacity: 1,
          backgroundColor: '#2A3F90'
        },
        // ! change width / padding if necessary
        '& svg': {
          width: 15,
          height: 15,
          borderRadius: 17,
          padding: 1,
          backgroundColor: '#2A3F90'
        },
        '&.Mui-disabled + span': {
          backgroundColor: '#2A3F90',
          border: 'none'
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
          backgroundColor: '#2A3F90'
        }
      }
    }
  }));

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: '#2A3F90',
      color: theme.palette.common.white
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14
    }
  }));

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover
    },
    '&:last-child td, &:last-child th': {
      border: 0
    }
  }));

  const StyledTable = styled(Table)(() => ({
    border: `1px solid #2A3F90`
  }));

  const handleChangeHtml = () => {
    if (verHtml === false && rowsPerPage !== rowsPerPageOptions[0]) {
      const currentIndex = rowsPerPageOptions.indexOf(rowsPerPage);
      const newIndex = currentIndex - 1;
      const newRowsPerPage = rowsPerPageOptions[newIndex];
      setRowsPerPage(newRowsPerPage);
    }
    setVerHtml(!verHtml);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const body = (
    <Box backgroundColor="white" height="100%" width="100%">
      <Box display="flex" height="10%" width="100%" alignItems="right" mr={5}>
        <IconButton
          color="success"
          variant="outlined"
          onClick={() => {
            setOpenModal(false);
          }}
          sx={{ marginLeft: '16px' }}
        >
          <CloseIcon />
        </IconButton>
      </Box>

      <Box height="85%" width="90%" ml={3} mr={3} justifyContent="center">
        {/* {!isEmpty(valueToShow.explanation) && (
          <Typography variant="h6">{valueToShow.explanation}</Typography>
        )} */}
        <Box ml={3} mr={3}>
          {!isEmpty(valueToShow) && (
            <Box width="60%" ml={3} mr={3} display="column">
              {Object.keys(valueToShow.content).map(key => (
                <>
                  {verHtml === true ? (
                    <tr key={uuid()} onClick={() => {}}>
                      {Array.isArray(valueToShow.content[key]) && isAnnotationState === true ? (
                        <div
                          // eslint-disable-next-line react/no-danger
                          dangerouslySetInnerHTML={{
                            __html: getPopupAnnotations(valueToShow.content[key], '80vw')
                          }}
                        />
                        // <Alert severity="info">Funcionalidad en desarrollo</Alert>
                      ) : (
                        // eslint-disable-next-line react/no-danger
                        <div dangerouslySetInnerHTML={{ __html: valueToShow.content[key] }} />
                      )}
                    </tr>  
                  ) : (
                    <Box
                      component="form"
                      sx={{
                        display: 'flex',
                        mb: 2,
                        width: '100%'
                      }}
                      noValidate
                      autoComplete="off"
                    >
                      <tr key={uuid()} onClick={() => {}}>
                        {Array.isArray(valueToShow.content[key]) && isAnnotationState === true ? (
                          <Typography variant="h6">{key}: {getPopupAnnotations(valueToShow.content[key], '80vw')}</Typography>
                        ) : (
                          <Typography variant="h6">{key}: {valueToShow.content[key]}</Typography>
                        )}
                      </tr>
                    </Box>
                  )}
                </>
              ))}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );

  React.useEffect(() => {
    const fetchTableLayer = async () => {
      isAnnotationState = !!(isAnnotationsLayer(layer) || isAnnotationsRealTime(layer));
      try {
        const { coordinates, tableBody, tableTitle } = await loadTableLayer(layer);
        const result = tableBody.map((item, index) => {
          const content = tableTitle.reduce((acc, titleItem, idx) => {
            acc[titleItem] = item[idx];
            return acc;
          }, {});
          return {
            content,
            coordinates: coordinates[index]
          };
        });
        setContentTable(result);
        setContentHeader(Object.keys(result[0].content));
        if (result.length < rowsPerPage) {
          setRowsPerPage(rowsPerPageOptions.find(option => option <= result.length))
        }
      } catch (err) {
        // Teide error de sacar coordenadas cuadno no hay datos de las layers provenientes de MapBoxGL
        // Bert.alert(`${err}`, 'danger');
      }
    };
    fetchTableLayer();
  }, [layer]);

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
        mb: 2
      }}
      noValidate
      autoComplete="off"
    >
      {isEmpty(contentTable) ? (
        <Alert severity="info">Esta layer no contiene datos.</Alert>
      ) : (
        <>
          <TableContainer component={Paper}>
            <StyledTable aria-label="customized table" size="small" stickyHeader>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center" justifyContent="center">
                    <MaterialUISwitch
                      checked={verHtml}
                      checkedIcon={<HtmlIcon />}
                      onClick={handleChangeHtml}
                    />
                  </StyledTableCell>
                  {contentHeader.map(header => (
                    <StyledTableCell key={header}>{header}</StyledTableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {contentTable
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map(row=> (
                    <StyledTableRow key={uuid()}>
                      <StyledTableCell>
                        <Stack
                          color="inherit"
                          size="small"
                          direction="row"
                          justifyContent="center"
                          alignItems="center"
                          spacing={0}
                        >
                          {isMapProp === true && (
                            <IconButton
                              size="small"
                              aria-label="Go"
                              style={{
                                color: '#2A3F90',
                                
                              }}
                              onClick={() => {
                                if (Array.isArray(row.coordinates[0])) {
                                  // Aplana el array de coordenadas
                                  const flattenCoordinates = () =>{
                                    let flatArray = [];
                                    row.coordinates.forEach(item => {
                                      if (Array.isArray(item)) {
                                        flatArray = flatArray.concat(flattenCoordinates(item));
                                      } else {
                                        flatArray.push(item);
                                      }
                                    });
                                    return flatArray;
                                  }
                                  const flatCoordinates = flattenCoordinates(row.coordinates);
                                  // Filtrar elementos que no son coordenadas válidas (e.g., no son pares de números)
                                  const validCoordinates = flatCoordinates.filter(coord => Array.isArray(coord) && coord.length === 2 && typeof coord[0] === 'number' && typeof coord[1] === 'number');
                                  // Crea un FeatureCollection de puntos
                                  const points = validCoordinates.map(coord => turf.point(coord));
                                  const featureCollection = turf.featureCollection(points);
                                  const centroid = turf.centroid(featureCollection);
                                  setGoToCoordinates(centroid);
                                } if (typeof row.coordinates[0] === 'number') {
                                  setGoToCoordinates([row.coordinates[1], row.coordinates[0]]);
                                }                                
                              }}
                            >
                              <LocationOnIcon />
                            </IconButton>
                          )}
                          <IconButton
                            size="small"
                            aria-label="Open"
                            style={{
                              color: '#2A3F90'
                            }}
                            onClick={() => {
                              setOpenModal(true);
                              setValueToShow(row);
                            }}
                          >
                            <OpenInFullIcon />
                          </IconButton>
                        </Stack>
                      </StyledTableCell>
                      {contentHeader.map(header => (
                        <StyledTableCell key={header}>
                          {Object.prototype.hasOwnProperty.call(row.content, header) ? (
                            <>
                              {verHtml === true ? (
                                <tr key={uuid()} onClick={() => {}}>
                                  {Array.isArray(row.content[header]) &&
                                  isAnnotationState === true ? (
                                      <div
                                        // eslint-disable-next-line react/no-danger
                                        dangerouslySetInnerHTML={{
                                          __html: getPopupAnnotations(row.content[header], '20vw')
                                        }}
                                      />
                                      // <Alert severity="info">Funcionalidad en desarrollo</Alert>
                                    ) : (
                                    // eslint-disable-next-line react/no-danger
                                      <div
                                        dangerouslySetInnerHTML={{ __html: row.content[header] }}
                                      />
                                    )}
                                </tr>
                              ) : (
                                <tr key={uuid()} onClick={() => {}}>
                                  {Array.isArray(row.content[header]) &&
                                isAnnotationState === true ? (
                                      <Typography variant="body2"> {getPopupAnnotations(row.content[header], '20vw')}</Typography>
                                    ) : (
                                      <Typography variant="body2"> {row.content[header]}</Typography>
                                    )}
                                </tr>
                              )}
                            </>
                          ) : (
                            ''
                          )}
                        </StyledTableCell>
                      ))}
                    </StyledTableRow>
                  ))}
              </TableBody>
              <TableFooter>
                <TableRow>
                  <TablePagination
                    rowsPerPageOptions={rowsPerPageOptions}
                    colSpan={contentHeader.length}
                    count={contentTable.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{ display: 'flex', justifyContent: 'flex-start' }}
                  />
                </TableRow>
              </TableFooter>
            </StyledTable>
          </TableContainer>
          <Modal
            open={openModal}
            onClose={() => setOpenModal(false)}
            style={{
              position: 'absolute',
              bgcolor: 'white',
              top: '0%',
              left: '0%'
            }}
          >
            {body}
          </Modal>
        </>
      )}
    </Box>
  );
};
TableComponent.defaultProps = {
  rowsInitial: 5,
  isMapProp: false,
  ViewHtml: false
};
TableComponent.propTypes = {
  isMapProp: PropTypes.bool,
  layer: PropTypes.object.isRequired,
  rowsInitial: PropTypes.number,
  ViewHtml: PropTypes.bool
};

export default TableComponent;
